import { Component, Inject, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PortalUser } from '@/common/components/ecorr-store/portal-user/portal-user';
import { portalUserSelector } from '@/common/components/ecorr-store/portal-user/portal-user.selector';
import { PortalUserState } from '@/common/components/ecorr-store/portal-user/portal-user.state';
import { NotificationOptDialogData } from '../../dialogs-data/notification-opt-dialog-data';
import { NotificationOptDialogHttpService } from '../../services/notification-opt-dialog-http.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-notification-opt-dialog',
    templateUrl: './notification-opt-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule
    ],
    providers: [
        NotificationOptDialogHttpService
    ]
})
export class NotificationOptDialogComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    private matDialogRef = inject(MatDialogRef<NotificationOptDialogComponent>);
    private notificationOptDialogHttpService = inject(NotificationOptDialogHttpService);
    private store = inject(Store<PortalUserState>);

    public notificationOptDialogData = inject<NotificationOptDialogData>(MAT_DIALOG_DATA);

    // Signals for reactive state
    private answered = signal<boolean>(false);
    private user = signal<PortalUser | null>(null);
    private confirmationMessage = signal<string>('');
    private actionMessage = signal<string>('Please click \'REPORT NOW\' on your survey card to begin your survey.');

    // Computed properties
    isAnswered = computed(() => this.answered());
    currentUser = computed(() => this.user());
    currentConfirmationMessage = computed(() => this.confirmationMessage());
    currentActionMessage = computed(() => this.actionMessage());

    constructor() {
        this.store.select(portalUserSelector)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(user => {
                this.user.set(user);
            });
    }

    ngOnInit() {
    }

    confirm() {
        const currentUser = this.currentUser();
        if (this.notificationOptDialogData.surveyInstanceId != null && currentUser && currentUser.userAccountId) {
            this.notificationOptDialogHttpService.updatePaperlessOptToY(currentUser.userAccountId, this.notificationOptDialogData.surveyInstanceId)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: (response) => {
                        this.answered.set(true);
                        if (this.notificationOptDialogData.surveyName.includes('2022 Economic Census')){
                            this.confirmationMessage.set('Thank you! Please check your email for a message with helpful links and resources regarding the 2022 Economic Census.'); 
                            this.actionMessage.set('');
                        }else{
                            this.confirmationMessage.set('Thank you! Future reminders and notifications for the '+ this.notificationOptDialogData.surveyName +' will be by email and/or phone.');
                        }
                    },
                    error: (error: any) => {
                        console.error('notification-opt-dialog updatePaperlessOptToY error', error);
                    }
                });
        }
    }

    cancel() {
        const currentUser = this.currentUser();
        if (this.notificationOptDialogData.surveyInstanceId != null && currentUser && currentUser.userAccountId) {
            this.notificationOptDialogHttpService.updatePaperlessOptToN(currentUser.userAccountId, this.notificationOptDialogData.surveyInstanceId)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: (response) => {
                        this.answered.set(true);
                        this.confirmationMessage.set('Thank you! You will continue to receive future reminders and notifications by mail, as well as email and phone.');
                    },
                    error: (error: any) => {
                        console.error('notification-opt-dialog updatePaperlessOptToN error', error);
                    }
                });
        }
    }

    close(value: any) {
        this.matDialogRef.close(value);
    }

}
